import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const ModalTitle = ({ children, className }) => {
  return (
    <div className={classNames(styles.container, className)} data-testid="ModalTitle">
      {children}
    </div>
  );
};

export default ModalTitle;
